import { Link } from "react-router"

export interface MoreDetailsCellRendererProps {
    url: string,
    label: string

}

const MoreDetailsCellRenderer = (props: MoreDetailsCellRendererProps) => {

    return (
        <div>
          <Link to={props.url}>{props.label}</Link>
        </div>
      );

  };

  export default MoreDetailsCellRenderer;
